import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { QuantityWarningInfo } from '../../interfaces/Case';

export interface QuantityWarningDialogProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  title: string;
  message: string;
  quantityLabel: string;
  yesLabel: string;
  noLabel: string;
  partInfo: QuantityWarningInfo | null;
}

const QuantityWarningDialog: React.FC<QuantityWarningDialogProps> = ({
  open,
  onConfirm,
  onClose,
  title,
  message,
  quantityLabel,
  yesLabel,
  noLabel,
  partInfo
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <WarningIcon style={{ color: '#f57c00' }} />
          <span style={{ fontWeight: 600, fontSize: 16 }}>{title}</span>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: 'rgba(0, 0, 0, 0.87)', marginBottom: partInfo ? 12 : 0 }}>
          {message}
        </DialogContentText>
        {partInfo && (
          <div style={{ background: 'rgba(0,0,0,0.04)', borderRadius: 6, padding: '8px 12px' }}>
            <div><strong>{quantityLabel}:</strong> {partInfo.quantity}</div>
          </div>
        )}
      </DialogContent>
      <DialogActions style={{ padding: '8px 16px 16px' }}>
        <Button variant="outlined" color="default" onClick={onClose}>
          {noLabel}
        </Button>
        <Button variant="contained" color="secondary" onClick={onConfirm}>
          {yesLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuantityWarningDialog;
